module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section",
    attrs: {
      "id": "instructions"
    }
  }, [_c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _c('temporal-notification', {
    attrs: {
      "type": "success",
      "show": _vm.showSuccess
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.successMessage))])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['instructions']))]), _c('div', {
    staticClass: "panel-block is-paddingless"
  }, [(_vm.intros === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : (!_vm.intros.length) ? _c('div', {
    staticClass: "container"
  }, [_c('i', [_vm._v(_vm._s(_vm.tokens['msg_no_instructions']))])]) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['name']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['text']))]), _c('th', [_c('div', {
    staticClass: "is-pulled-right"
  }, [_vm._v(_vm._s(_vm.tokens['actions']))])])])]), _c('tbody', _vm._l((_vm.intros), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _c('td', {
      staticClass: "keep-lines"
    }, [_vm._v(_vm._s(item.textsSummary()))]), _c('td', [_c('div', {
      staticClass: "is-pulled-right is-flex"
    }, [_c('button', {
      staticClass: "button is-light",
      attrs: {
        "title": _vm.tokens['tit_edit']
      },
      on: {
        "click": function($event) {
          _vm.edit(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _c('button', {
      staticClass: "button is-danger",
      attrs: {
        "title": _vm.tokens['tit_delete']
      },
      on: {
        "click": function($event) {
          _vm.remove(item)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])])])])
  }))])])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_new']))]), _c('div', {
    staticClass: "panel-block is-paddingless"
  }, [_c('intro-editor', {
    staticClass: "control",
    attrs: {
      "action": _vm.tokens['create'],
      "name-editable": true,
      "reload": _vm.resetNew
    },
    on: {
      "save": _vm.tryToCreate
    }
  })], 1)]), (_vm.toEdit) ? _c('modal-container', {
    attrs: {
      "title": _vm.tokens['hdr_editor']
    },
    on: {
      "close": _vm.closeEditor
    }
  }, [_c('intro-editor', {
    attrs: {
      "action": _vm.tokens['save'],
      "show-labels": true,
      "intro": _vm.toEdit
    },
    on: {
      "save": _vm.saveEdited
    }
  })], 1) : _vm._e(), (_vm.toDelete) ? _c('remove-warning', {
    attrs: {
      "object": "instruction",
      "name": _vm.toDeleteName
    },
    on: {
      "close": _vm.removeWarningClosed
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-248409ab"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/Instructions.vue
// module id = 409
// module chunks = 0